import { Header } from '../../components/common';
import './AgentStyle.css'
import { AgentTable } from './components/AgentTable';
import { lazy, Suspense, useState } from 'react';
import { createAgent, deleteAgent, updateAgent } from '../../actions/agent';
import { AgentForm } from './components/AgentForm';
import { CircularProgress } from '@mui/material';
import iziToast from 'izitoast';
import { internalServerError } from '../../utils/consts/pathRoutes';

const ModalCustom = lazy(() => import('../../components/ModalCustom/ModalCustom'));

export const AgentPage = () => {
  const [editingAgent, setEditingAgent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEdit = (agent) => {
    setEditingAgent(agent);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setEditingAgent(null);
    setIsModalOpen(false);
  };

  const handleSave = async (formData) => {
    try {
      if (editingAgent) {
        await updateAgent(editingAgent.id, formData);
      } else {
        await createAgent(formData);
      }
      handleClose();
      window.location.reload();
    } catch (e) {
      iziToast.error({
        message: internalServerError(e),
        position: "topRight",
        color: "#FFF2ED"
      });
    }
  };

  const handleDelete = async () => {
    try {
      await deleteAgent(editingAgent.id)
      handleClose();
      window.location.reload();
    } catch (e) {
      iziToast.error({
        message: internalServerError(e),
        position: "topRight",
        color: "#FFF2ED"
      });
    }
  }

  return <>
    <Header />
    <div className="agentBlock">
      <AgentTable onEdit={handleEdit} />
      {isModalOpen && (
        <Suspense fallback={<CircularProgress color="warning" />}>
          <ModalCustom active={isModalOpen} setActive={setIsModalOpen} onCancel={handleClose}>
            <AgentForm
              agent={editingAgent}
              onSave={handleSave}
              onCancel={handleClose}
              onDelete={handleDelete}
            />
          </ModalCustom>
        </Suspense>
      )}
    </div>
  </>
}
